// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1aBPZ","title":"BackImages_title__J4MPm","images":"BackImages_images__1k08r"};